import { deepEqual } from "@dataspecer/utilities";
import { InMemoryEntityModel } from "../../entity-model/in-memory-entity-model.js";
import { transformCoreResources } from "./transform-core-resources.js";
import { RDFS_MODEL } from "../../model/known-models.js";
import { buildPimResources } from "./transform-semantic-to-pim.js";
export class PimStoreWrapper extends InMemoryEntityModel {
    pimStore;
    urls;
    label = {};
    /**
     * Maps the old id of PimAssociationEnd to the new id of SemanticModelRelationship and if it is a source (true) or target (false).
     */
    relationshipMapping = {};
    constructor(pimStore, id, alias, urls, label) {
        super(id);
        this.pimStore = pimStore;
        this.alias = alias;
        this.urls = urls;
        this.label = label ?? (alias ? { en: alias } : {});
    }
    fetchFromPimStore() {
        const result = transformCoreResources(this.pimStore.resources, this.relationshipMapping);
        const deleted = [];
        const updated = {};
        const currentEntities = this.getEntities();
        // First remove entities that are not present
        const oldIris = Object.keys(currentEntities);
        for (const iri of oldIris) {
            if (!result[iri]) {
                deleted.push(iri);
            }
        }
        // Update new
        for (const iri in result) {
            const entity = result[iri];
            if (!deepEqual(entity, currentEntities[iri])) {
                updated[iri] = entity;
            }
        }
        this.change(updated, deleted);
    }
    serializeModel() {
        return {
            type: RDFS_MODEL,
            id: this.id,
            alias: this.alias,
            pimStore: this.pimStore,
            urls: this.urls,
            label: this.label,
        };
    }
}
/**
 * Converts PIM serialization (js object) into an entity record with semantic
 * entities.
 */
export function serializationToPimModelEntities(serialization) {
    const modelData = { ...serialization };
    const adapter = new PimStoreWrapper(modelData.pimStore, modelData.id, "model", modelData.urls, modelData.label);
    adapter.fetchFromPimStore();
    delete modelData.pimStore;
    /**
     * The main entity represents the model itself. Currently it is just a dump
     * of the data from the root of the blob.
     */
    const mainEntity = {
        ...modelData,
        id: modelData.id,
        type: [],
    };
    if (!mainEntity.label || Object.keys(mainEntity.label).length === 0) {
        mainEntity.label = {};
        if (mainEntity.alias) {
            mainEntity.label.en = mainEntity.alias;
        }
    }
    delete mainEntity.alias;
    const entities = {
        ...adapter.getEntities(),
        [mainEntity.id]: mainEntity,
    };
    return {
        entities,
        adapter,
    };
}
/**
 * Serializes the RDFS (PIM store wrapper) model. Inverse of
 * {@link serializationToPimModelEntities}.
 */
export function rdfsModelToSerialization(modelId, entities) {
    const mainEntity = entities[modelId];
    const mainEntityMetadata = {
        ...mainEntity,
    };
    delete mainEntityMetadata.id;
    delete mainEntityMetadata.type;
    return {
        ...mainEntityMetadata,
        type: RDFS_MODEL,
        id: modelId,
        pimStore: { resources: buildPimResources(entities, modelId) },
    };
}
//# sourceMappingURL=pim-store-wrapper.js.map